<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input v-model="listQuery.title" clearable class="filter-item" style="width: 200px;" placeholder="请输入消息标题" />
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">查找</el-button>
      <el-button class="filter-item" type="success" icon="el-icon-edit" @click="handleCreate">发送消息</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" border fit highlight-current-row>
      <el-table-column align="center" label="ID" prop="id" width="80" />
      <el-table-column align="center" label="标题" prop="title" min-width="150" />
      <el-table-column align="center" label="内容" prop="content" min-width="250" />
      <el-table-column align="center" label="发送给管理员" prop="adminId" width="120">
        <template slot-scope="scope">
          <el-tag :type="scope.row.adminId ? 'success' : 'info'">
            {{ scope.row.adminId ? '管理员' : '全部用户' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="发送时间" prop="addTime" width="180" />
      <el-table-column align="center" label="操作" width="200">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleReply(scope.row)">回复</el-button>
          <el-button type="danger" size="mini" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />

    <!-- 发送/回复对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
      <el-form ref="dataForm" :model="dataForm" label-width="100px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="dataForm.title" placeholder="请输入消息标题" />
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input v-model="dataForm.content" type="textarea" :rows="6" placeholder="请输入消息内容" />
        </el-form-item>
        <el-form-item label="发送对象">
          <el-radio-group v-model="dataForm.adminId">
            <el-radio :label="0">全部用户</el-radio>
            <el-radio :label="1">仅管理员</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listNotice, createNotice, deleteNotice } from '@/api/notice'
import Pagination from '@/components/Pagination'

export default {
  name: 'MessageList',
  components: { Pagination },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        title: undefined
      },
      dialogVisible: false,
      dialogTitle: '发送消息',
      dataForm: {
        id: undefined,
        title: '',
        content: '',
        adminId: 0
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      listNotice(this.listQuery).then(response => {
        this.list = response.data.data.list || response.data.list || []
        this.total = response.data.data.total || response.data.total || 0
        this.listLoading = false
      }).catch(() => {
        this.list = []
        this.total = 0
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleCreate() {
      this.dialogTitle = '发送消息'
      this.dataForm = { id: undefined, title: '', content: '', adminId: 0 }
      this.dialogVisible = true
    },
    handleReply(row) {
      this.dialogTitle = "回复消息"
      this.dataForm = {
        id: row.id,
        title: "Re: " + row.title,
        content: "",
        adminId: 0,
        replyTo: row.id
      }
      this.dialogVisible = true
    },
    handleReply(row) {
      this.dialogTitle = '回复消息'
      this.dataForm = { id: undefined, title: 'Re: ' + row.title, content: '', adminId: 0 }
      this.dialogVisible = true
    },
    submitForm() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          createNotice(this.dataForm).then(() => {
            this.dialogVisible = false
            this.$notify.success({ title: '成功', message: '发送成功' })
            this.getList()
          }).catch(() => {
            this.$notify.error({ title: '失败', message: '发送失败' })
          })
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确定删除该消息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteNotice(row).then(() => {
          this.$notify.success({ title: '成功', message: '删除成功' })
          this.getList()
        })
      })
    }
  }
}
</script>
